module.exports = __webpack_public_path__ + "img/resources3.aa463e3f.svg";